<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="default" color="#7bff76" type="square-loader" [fullScreen]="false">
    <p style="color: white"> Loading... </p>
</ngx-spinner>
<div class="content-wrapper">
    <div class="col-12">
        <div class="card ">
            <div class="card-header bg-primary"> <i class="fas fa-truck"></i> ตรวจสอบการใช้คิวโซน[{{zshow}}] รอบที่
                {{rshow}}</div>
            <div class="card-body" [formGroup]="SetectZone">
                <div class="row justify-content-md-center">
                    <div class="col-md-auto">
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <label class="input-group-text" for="inputSelect01">1. เลือกโซน</label>
                            </div>
                            <select class="custom-select" formControlName="zone" id="inputSelect01">
                                <option [ngValue]="'all'">คิวทั้งหมด </option>
                                <option [ngValue]="'CT'">คิวกลาง-CT</option>
                                <option *ngFor="let item of zonelist" [ngValue]="item.SUPZONE">
                                    {{item.SUPZONE}}
                                </option>
                            </select>
                        </div>
                        <!--<mat-form-field appearance="fill">
                            <mat-label>1. เลือกโซน</mat-label>
                            <mat-select required formControlName="zone">
                                <mat-option [value]="'all'">คิวทั้งหมด </mat-option>
                                <mat-option [value]="'CT'">คิวกลาง-CT</mat-option>
                                <mat-option *ngFor="let item of zonelist" [value]="item.SUPZONE">
                                    {{item.SUPZONE}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>-->
                    </div>
                    <div class="col-md-auto">
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <label class="input-group-text" for="inputSelect02">2. เลือกรอบ</label>
                            </div>
                            <select class="custom-select" formControlName="round" id="inputSelect02">
                                <option *ngFor="let item of roundlist" [ngValue]="item.loop_id.trim()">
                                    {{item.loop_id}}
                                </option>
                            </select>
                        </div>
                        <!--<mat-form-field appearance="fill">
                            <mat-label>2. เลือกรอบ</mat-label>
                            <mat-select required formControlName="round">
                                <mat-option *ngFor="let item of roundlist" [value]="item.loop_id.trim()">
                                    {{item.loop_id}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>-->
                    </div>
                    <div class="col-md-auto">
                        <ul class="nav nav-pills nav-fill mb-3" id="vert-tabs-tab" role="tablist"
                            aria-orientation="horizontal">
                            <li class="nav-item outline-primary" role="presentation">
                                <a class="nav-item btn btn-outline-primary" id="tabs-tab2"
                                    (click)="LoadCheckusedbyzone(1);" data-toggle="pill">คิวล็อก</a>
                            </li>
                            <li class="nav-item outline-primary" role="presentation">
                                <a class="nav-item btn btn-outline-success" id="tabs-tab2"
                                    (click)="LoadCheckusedbyzone(3);" data-toggle="pill">คิวรถตัด</a>
                            </li>
                            <li class="nav-item outline-primary" role="presentation">
                                <a class="nav-item btn btn-outline-danger" id="tabs-tab2"
                                    (click)="LoadCheckusedbyzone(0);" data-toggle="pill">คิวล็อก+คิวรถตัด</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-auto" *ngIf="usedlist.length>0">
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <button class="btn btn-outline-success" (click)="ExportExcel();">
                                    <i class="fas fa-download"></i>
                                    <!--<span class="badge badge-light">{{usedlist.length}}</span>-->
                                </button>
                            </div>
                            <input type="text" class="form-control" placeholder="ค้นหา" formControlName="txtfind">
                        </div>
                    </div>
                </div>

                <div class="table-responsive p-2" style="height: 700px">
                    <table class="table table-hover table-head-fixed text-nowrap table-bordered border-primary" #table>
                        <thead>
                            <tr class="text-center">
                                <th scope="col">#</th>
                                <th scope="col" class="sticky-col" style="background-color:rgba(116, 255, 197, 0.904)">
                                    คิวที่</th>
                                <th scope="col">โซนQ</th>
                                <th scope="col">กลุ่มคิว</th>
                                <th scope="col">กลุ่มตัด</th>
                                <th scope="col">ใบคิว</th>
                                <th scope="col">เลขแปลง</th>
                                <th scope="col">ชื่อ-สกุล</th>
                                <th scope="col">ทะเบียนรถ</th>
                                <th scope="col">สถานะคิว</th>
                                <th scope="col">เวลาใช้คิว</th>
                                <th scope="col">วันเวลาแจ้งคิว</th>
                                <th scope="col">อ้อยสด/ไฟ</th>
                                <th scope="col">อ้อยเข้า</th>
                                <th scope="col">CCS</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of usedlist | filter:SetectZone.value.txtfind ;index as i"
                                style="text-align: center;">
                                <td>{{i+1}}</td>
                                <td class="sticky-col" style="background-color:rgba(103, 255, 153, 0.527)">
                                    <span class="badge text-bg-light">{{item.truck_type}}</span>{{item.q_idQ}}
                                </td>
                                <td>{{item.supzoneQ}}</td>
                                <td>{{item.groupcodeQ}}</td>
                                <td>{{item.groupcode_use}}</td>
                                <td>{{item.truck_q}}</td>
                                <td>{{item.landno}}</td>
                                <td class="text-left">{{item.fmname}}</td>
                                <td>{{item.REGTRUCK}}</td>
                                <td [ngStyle]="{ 'background-color': getBGColor('205,92,92',item.print_q) }">
                                    {{item.q_desc}}</td>
                                <td>{{item?.q_timeused}}</td>
                                <td>{{THtoLocalstring2(item.date_in)}}</td>
                                <td>
                                    <span *ngIf="item.cane_type == '1'">
                                        <span class="badge badge-success">อ้อยสด</span>
                                    </span>
                                    <span *ngIf="item.cane_type == '2'">
                                        <span class="badge badge-danger">อ้อยไฟ</span>
                                    </span>
                                </td>
                                <td>{{item.wgt_net | number}}</td>
                                <td>{{item.ccs_value | number}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    </div>
</div>
<app-footer></app-footer>
